import React, { useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Checkbox, CheckboxLabel, CheckboxCount } from './styles';

interface Props {
  stops: { text: string; count: number }[];
  values: string[];
  onChange: (values: string[]) => void;
  onOptionChange?: (value: string, isChecked: boolean) => void;
}

const Stops = ({ stops, values, onChange, onOptionChange }: Props) => {
  const { t } = useStoreTranslation();

  const isChecked = useCallback((checkValue: string) => Boolean(values.find((item) => item === checkValue)), [values]);

  const handleChange = (newValue: string) => {
    if (isChecked(newValue)) {
      onChange([...new Set(values.filter((item) => item !== newValue))]);
    } else {
      onChange([...new Set([...values, newValue])]);
    }
    if (onOptionChange) onOptionChange(newValue, !isChecked(newValue));
  };

  return (
    <section>
      {stops.map((stop) => {
        const stopValue = stop.text.replace('Stops', '');

        const label = (() => {
          switch (stopValue) {
            case '0':
              return 'flightsFilters.stops.direct';
            case '1':
              return 'flightsFilters.stops.oneStop';
            default:
              return 'flightsFilters.stops.twoOrMoreStops';
          }
        })();

        return (
          <Checkbox key={stop.text} checked={isChecked(stopValue)} onChange={() => handleChange(stopValue)}>
            <CheckboxLabel content={t(label)} onClick={() => handleChange(stopValue)} />
            <CheckboxCount>{stop.count}</CheckboxCount>
          </Checkbox>
        );
      })}
    </section>
  );
};

export default Stops;
